const SEARCH_REFERENCE_TEXT_LENGTH = 50;
const REALIGNMENT_SEARCH_WINDOW = 100;
const REALIGNMENT_SIMILARITY_THRESHOLD = 0.9;
const SCORE_WEIGHT_TEXT = 0.6;
const SCORE_WEIGHT_CONTEXT = 0.2;
const ANNOTATION_DEFAULT_COLOR = "rgb(253, 214, 96)";

export { ANNOTATION_DEFAULT_COLOR, REALIGNMENT_SEARCH_WINDOW, REALIGNMENT_SIMILARITY_THRESHOLD, SCORE_WEIGHT_CONTEXT, SCORE_WEIGHT_TEXT, SEARCH_REFERENCE_TEXT_LENGTH };
//# sourceMappingURL=config.js.map
